<template>
  <div>
    <Row class="form-content" >
        <Form ref="formValidate" :model="formValidate"  label-position="left" :rules="ruleValidate" :label-width="200" @submit.native.prevent>
          <span>
             {{caseCode}}
          </span>
            <FormItem label="已支付金额" prop="amount">
              <Input type="number" v-model.trim="formValidate.amount" placeholder="请输入已支付金额" >
              <template #append>
              <span class="yuan">元</span>
            </template>
            </Input>
            </FormItem>
            <FormItem label="付款人" prop="drawee">
              <Input v-model.trim="formValidate.drawee" placeholder="请输入付款人" />
            </FormItem>
            <FormItem label="付款日期" prop="paymentTime">
                <DatePicker :value="formValidate.paymentTime" type="date" placement="bottom-end" :placeholder="$t('SelectTime')"
                      style="width:100%" @on-change="getTime"
          />
            </FormItem>
          <FormItem label="付款凭证" prop="attachment">
            <MobilefileUpload :upload-config="uploadConfig" class="upload" :default-list="defaultList" @getFileList="getFileList" />
          </FormItem>
          <Row class="btn-style">
            <Button class="clear-button" @click.stop="clear('formValidate')">
              清空
            </Button>
            <Button class="submit-button" @click.stop="submit('formValidate')">
              提交
            </Button>
          </Row>
        </Form>
      </Row>
      <!-- <Modal
      v-model="wxStrl"
          :title="提示"
          width="80%"
          class-name="wx-model"
          :footer-hide="true">
          <span>提交成功</span>
          <span>提交失败，请重新提交</span>

        </Modal> -->

    </div>
    
  </template>
  
  <script>
  
  import MobilefileUpload from '../uploadIntelligence/components/fileUpload.vue'
  
  export default {
    metaInfo: {
      meta: [
        { name: 'viewport', content: 'width=device-width' }
      ]
    },
    components: {
      MobilefileUpload
    },
    data () {
      const validatePrice = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('产品单价不能为空'))
        }
        if (isNaN(value)) {
          return callback(new Error('请输入数字'))
        }
        const arr = value.split('.')
        if (arr.length === 1 || arr.length === 2) {
          if (Number(arr[0]) > 9999999999) {
            return callback(new Error('整数部分不能超过10位'))
          }
          if (Number(arr[1]) > 99) {
            return callback(new Error('小数部分不能超过2位'))
          }
        } else {
          return callback(new Error('请输入数字'))
        }
        callback()
      }
      const validateSaleNum = (rule, value, callback) => {
        if (isNaN(value)) {
          return callback(new Error('请输入数字'))
        }
        callback()
      }
      return {
        submitLoading: false,
        formValidate: {
          caseId:'',
          agreementId:'',
          amount: '',
          drawee: '',
          paymentTime:'',
          attachment: []
        },
        ruleValidate: {
          amount: [
            { required: true, message: '请输入付款金额', trigger: 'blur' },
            { max: 16, message: '长度不能超过16个字符', trigger: 'blur' }
           
          ],
          drawee: [
            { required: true, message: '请输入付款人信息', trigger: 'blur' },
            { max: 64, message: '长度不能超过64个字符', trigger: 'blur' }
           
          ],
          paymentTime: [{ required: true, message: '请输选择时间', trigger: 'change' }],
          attachment: [{ required: true,type: 'array', message: '请上传文件', trigger: 'change' }]
        },
        uploadConfig: {},
        investigateTime: [],
        defaultList: [],
        wxStrl:false,
      }
    },
    created(){
      console.log('路由',this.$route.query);
      if(this.$route.query && this.$route.query.caseId !== ''){
        this.agreementId = this.$route.query.reconcileAgreementId
        this.caseId = this.$route.query.caseId
        this.caseCode = this.$route.query.caseCode
      }
    },
    mounted() {
      

      (function flexible(window, document) {
        
        var docEl = document.documentElement
        var dpr = window.devicePixelRatio || 1
  
        // adjust body font size
        // 设置 em 默认字体所对应的大小
        function setBodyFontSize() {
          if (document.body) {
            document.body.style.fontSize = 12 * dpr + 'px'
          } else {
            document.addEventListener('DOMContentLoaded', setBodyFontSize)
          }
        }
        setBodyFontSize()
        // 将视窗分为多少份
        // set 1rem = viewWidth / 10
        function setRemUnit() {
          var rem = docEl.clientWidth / 10
          docEl.style.fontSize = rem + 'px'
        }
  
        setRemUnit()
        // 当页面发生改变时，重新设置 rem 所对应的刻度值
        // reset rem unit on page resize
        window.addEventListener('resize', setRemUnit)
        window.addEventListener('pageshow', function(e) {
          // if (e.persisted) {
          setRemUnit()
          // }
        })
  
        // detect 0.5px supports
        if (dpr >= 2) {
          var fakeBody = document.createElement('body')
          var testElement = document.createElement('div')
          testElement.style.border = '.5px solid transparent'
          fakeBody.appendChild(testElement)
          docEl.appendChild(fakeBody)
          if (testElement.offsetHeight === 1) {
            docEl.classList.add('hairlines')
          }
          docEl.removeChild(fakeBody)
        }
      })(window, document)
      this.defaultTime()
    },
    methods: {
      // 提交数据
      submit (name) {
        // const a = window.location.origin + '/' + '#' + '/' + 'wxSuccess'
        // console.log('浏览器地址',a);
        console.log('叫阿斯顿',this.formValidate.attachment);
        let item = {
          fileName: this.formValidate.attachment[0].fileName,
              mediaType: this.formValidate.attachment[0].mediaType,
              smallUrl: this.formValidate.attachment[0].smallUrl,
              url: this.formValidate.attachment[0].url

        }
        this.wxStrl = true
        const ajaxData = {
          caseId:this.$route.query.caseId ,
          agreementId:this.agreementId,
          paymentTime:this.formValidate.paymentTime,
          amount: this.formValidate.amount,
          drawee: this.formValidate.drawee,
          attachment: item
        }
        this.$refs[name].validate((valid) => {
          console.log('jiaoyan ',valid);
          if (valid) {
            // this.submitLoading = true
            const url = '/business/reconcile/payment-record'
            this.$post(url, ajaxData).then(res => {
              if (res.code === 0) {
                // this.$Message.success('操作成功！')
                // this.submitLoading = false
                console.log('busu',window.location.origin);
                window.location.href =window.location.origin + '/#/wxSuccess'

                this.clearForm()
              } else {
                 this.$Message.error('操作失败！')
                // this.submitLoading = false
              }
            }).catch(err => {
              console.log(err)
              // this.submitLoading = false
            })
          }
        })
      },
      // 获取时间
      getTime (date) {
        this.formValidate.paymentTime = date
      },
      // 获取文件list
      getFileList (data) {
        this.formValidate.attachment = []
        if (data.length > 0) {
          data.forEach((item, index) => {
            const obj = {
              fileName: item.fileName,
              mediaType: item.mediaType,
              smallUrl: item.smallUrl,
              url: item.url
            }
            this.formValidate.attachment.push(obj)
            // this.formValidate.attachment = obj
          })
        }
      },
      // 获取时间默认值
      defaultTime() {
        const now = new Date()
        const nowDate = {
          year: now.getFullYear(),
          month: (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1),
          date: now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
        }
        this.formValidate.paymentTime = nowDate.year + '-' + nowDate.month + '-' + nowDate.date
      },
      clear(){
        this.clearForm()
      },
      // 清空表单
      clearForm() {
        for (const key in this.formValidate) {
          this.formValidate[key] = ''
        }
        this.formValidate.attachment = []
        this.defaultList = []
        this.defaultTime()
      }
    }
  }
  </script>
  
  <style scoped lang="sass">
  @import './wxShare.scss'
  </style>
  


// WEBPACK FOOTER //
// src/view/sharePage/wxShare.vue